"use strict";
/**
 * This is your main. This is where you re-export everything you want to be publicly available.
 *
 * The build enforces that the file has the same name as the global variable that is exported.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./components/Note"), exports);
__exportStar(require("./components/Certifier"), exports);
__exportStar(require("./components/CertificationIcon"), exports);
__exportStar(require("./components/DataConnectionIcon"), exports);
__exportStar(require("./components/CertificationTooltip"), exports);
__exportStar(require("./components/DataConnectionTooltip"), exports);
//# sourceMappingURL=CertificationWatermark.js.map